import GridPageAbstract from '../../GridPageAbstract';
import { ShopBulkIcon } from '../../../icons-lib/bulkIcons';
import DialogAbstract from '../../DialogAbstract';
import { GridDataAdapter } from '../../../adapters/GridDataAdapter';

export default class SmeCompaniesPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'smeCompanies';
        this.Server = this.props.context.getState().server.smeCompanies;

        this.headerStartIcon = ShopBulkIcon;

        this.exportButton = true;

        this.searchFields = ['name', 'email'];

        this.Head = [
            {
                id: 'name',
                label: 'smeName',
                alignRight: false,
                cell: 'Text',
                required: true
            },
            {
                id: 'email',
                label: 'owner',
                alignRight: false,
                cell: 'Text',
                required: true
            },
            {
                id: 'walletNumber',
                label: 'walletId',
                alignRight: false,
                cell: 'Text',
                disableEditor: true,
                object: 'wallet',
                display: 'walletNumber'
            },
            {
                id: 'balance',
                label: 'balance',
                alignRight: false,
                cell: 'Amount',
                type: 'amount',
                filterCell: 'Range',
                object: 'wallet',
                display: 'currentBalance'
            },
            {
                id: 'isActive',
                label: 'status',
                alignRight: false,
                cell: 'Boolean',
                filterCell: 'Boolean',
                trueLabel: 'smeActive',
                falseLabel: 'smeInactive',
                type: 'boolean'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ];
    }

    // Custom form fields for create mode
    getCreateFields() {
        return [
            {
                id: 'name',
                label: 'smeName',
                cell: 'Text',
                required: true
            },
            {
                id: 'email',
                label: 'ownerEmailAddress',
                cell: 'Text',
                required: true
            },
            {
                id: 'initialWalletBalance',
                label: 'balance',
                cell: 'Amount',
                type: 'amount',
                required: true,
                context: this.props.context
            },
            {
                id: 'isActive',
                label: 'smeActive',
                cell: 'Checkbox',
                defaultValue: true,
                trueLabel: 'smeActive',
                falseLabel: 'smeInactive'
            }
        ];
    }

    // Custom form fields for edit mode
    getEditFields() {
        return [
            {
                id: 'name',
                label: 'smeName',
                cell: 'Text',
                required: true
            },
            {
                id: 'email',
                label: 'ownerEmailAddress',
                cell: 'Text',
                required: true
            },
            {
                id: 'balance',
                label: 'currentBalance',
                cell: 'Amount',
                type: 'amount',
                object: 'wallet',
                display: 'currentBalance',
                disabled: true
            },
            {
                id: 'addBalance',
                label: 'addBalance',
                cell: 'Amount',
                type: 'amount',
                defaultValue: 0,
                context: this.props.context
            },
            {
                id: 'isActive',
                label: 'smeActive',
                cell: 'Boolean',
                trueLabel: 'smeActive',
                falseLabel: 'smeInactive'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                cell: 'Date',
                disableEditor: true
            }
        ];
    }

    dialogOpen(data) {
        const isEditMode = !!(data && data.id);
        const fields = isEditMode
            ? this.getEditFields()
            : this.getCreateFields();

        const dialogData = GridDataAdapter.transform(data, fields);
        this.setState({
            dialogOpen: true,
            dialogData,
            isEditMode,
            open: false
        });
    }

    renderDialog() {
        const fields = this.state.isEditMode
            ? this.getEditFields()
            : this.getCreateFields();

        return (
            <DialogAbstract
                key={`sme-companies-dialog-${
                    this.state.isEditMode ? 'edit' : 'add'
                }`}
                dialogOpen={this.state.dialogOpen}
                dialogData={this.state.dialogData}
                permissions={this.permissions}
                Name={this.Name}
                Head={fields}
                Server={this.Server}
                onSave={(data) => this.handleDialogOnSave(data)}
                onClose={() => this.handleDialogOnClose()}
            />
        );
    }
}
